import React, { useState, useRef, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  Typography,
  Box
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import * as XLSX from 'xlsx';

import CloseIcon from '@mui/icons-material/Close';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DownloadIcon from '@mui/icons-material/Download';
import ImageIcon from '@mui/icons-material/Image';

import { GetBaysByStoreId, CreateVmConfig } from 'api';
// import axios from 'axios';
import { useLocation } from 'react-router';

const VMConfigComponent = ({ open, onClose, storeId }) => {
  // eslint-disable-next-line no-unused-vars
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [vmName, setVmName] = useState('');
  const [selectedBay, setSelectedBay] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedBrand, setSelectedBrand] = useState('');
  const [parsedProducts, setParsedProducts] = useState([]);
  const [excelFileName, setExcelFileName] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const fileInputRef = useRef(null);
  const excelInputRef = useRef(null);

  const brands = ['Brand A', 'Brand B', 'Brand C'];

  const location = useLocation();

  const getBayIdFromPath = () => {
    const pathParts = location.pathname.split('/');
    return pathParts[pathParts.length - 1];
  };

  useEffect(() => {
    if (open && storeId) {
      fetchBays();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, storeId]);

  const fetchBays = async () => {
    try {
      const bayRes = await GetBaysByStoreId({ store_oid: storeId });

      console.log('bayRes', bayRes);

      if (bayRes?.data) {
        const bayList = bayRes.data.data;

        console.log('bayList', bayList);

        const bayIdFromUrl = getBayIdFromPath();

        console.log('bayIdFromUrl', bayIdFromUrl);
        const matchedBay = bayList.find((b) => b._id === bayIdFromUrl);
        if (matchedBay) {
          setSelectedBay(matchedBay.bay_id);
          setSelectedCategory(matchedBay.type);
        }
      }
    } catch (error) {
      console.error('Error loading bays:', error);
    }
  };

  // const UploadToBlob = async (sasUrl, file) => {
  //   return axios.put(sasUrl, file, {
  //     headers: {
  //       'x-ms-blob-type': 'BlockBlob',
  //       'Content-Type': file.type
  //     }
  //   });
  // };

  const handleSubmit = async () => {
    try {
      // Validate required fields
      if (!vmName.trim()) {
        alert('Please enter a VM name');
        return;
      }
      
      if (!startDate) {
        alert('Please select a start date');
        return;
      }
      
      if (!endDate) {
        alert('Please select an end date');
        return;
      }
      
      if (startDate > endDate) {
        alert('Start date cannot be after end date');
        return;
      }

      // let signed_url = '';

      // if (selectedImage) {
      //   const sasRes = await GenerateVmReferenceImageUploadUrl({});
      //   signed_url = sasRes.data.data?.signed_url;

      //   if (signed_url) {
      //     await UploadToBlob(signed_url, selectedImage);
      //   } else {
      //     throw new Error('Failed to get SAS URL.');
      //   }
      // }

      const formData = {
        // image_url: signed_url,
        image_url: '',
        vm_name: vmName,
        bay: selectedBay,
        category: selectedCategory,
        brand: selectedBrand,
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
        products: parsedProducts
      };

      const saveRes = await CreateVmConfig(formData);

      console.log('VM Config Data:', saveRes.data);
      handleReset();
      onClose();
    } catch (error) {
      console.error('Error during VM config submission:', error);
      alert('Something went wrong. Please check console for details.');
    }
  };

  const handleReset = () => {
    setSelectedImage(null);
    setImagePreview('');
    setVmName('');
    setSelectedBay('');
    setSelectedCategory('');
    setSelectedBrand('');
    setParsedProducts([]);
    setExcelFileName('');
    setStartDate(null);
    setEndDate(null);
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => setImagePreview(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleExcelUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setExcelFileName(file.name);

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      const products = jsonData.map((row) => ({
        shelf: row['Shelf'],
        local_id: row['LOC ID'],
        article_code: row['Article Code'],
        UPC: row['UPC'],
        Description: row['Description'],
        facings: Number(row['Facings']),
        vertical_facing: Number(row['Vertical Facings']),
        Depth_facings: Number(row['Depth Facings']),
        shelf_qty: Number(row['Shelf Qty']),
        remarks: row['Remarks/Tagging'] || ''
      }));

      setParsedProducts(products);
    };

    reader.readAsArrayBuffer(file);
  };

  const downloadSampleExcel = () => {
    const sampleData = [
      [
        'Shelf',
        'LOC ID',
        'Article Code',
        'UPC',
        'Description',
        'Facings',
        'Vertical Facings',
        'Depth Facings',
        'Shelf Qty',
        'Remarks/Tagging'
      ],
      [5, 7, 490853271, 8000500165607, 'TIC TAC SPEARMINT 13g PET', 1, 1, 19, 19, ''],
      [5, 8, 494354939, 8000500410974, 'TIC TAC STRAWBERRY 13g PET', 1, 1, 19, 19, ''],
      [5, 9, 491551912, 8901393019117, 'HAPPYDENT WAVE XYLITOL SGR FR GM 17g PET', 1, 1, 19, 19, '']
    ];

    const worksheet = XLSX.utils.aoa_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Product Sample');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'product_sample.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        VM Configuration
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box display="grid" gridTemplateColumns={{ md: '1fr 1fr' }} gap={4}>
          <Box>
            <Typography variant="h6">VM Image</Typography>
            <Box
              border="2px dashed #ccc"
              p={2}
              textAlign="center"
              minHeight="280px"
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              bgcolor="#f9fafb"
              borderRadius={2}
            >
              {imagePreview ? (
                <Box width="100%">
                  <img
                    src={imagePreview}
                    alt="VM Preview"
                    style={{ width: '100%', height: 224, objectFit: 'contain', borderRadius: 8, border: '1px solid #ddd' }}
                  />
                  <Button variant="outlined" fullWidth onClick={() => fileInputRef.current?.click()} sx={{ mt: 2 }}>
                    Change Image
                  </Button>
                </Box>
              ) : (
                <>
                  <ImageIcon sx={{ fontSize: 48, color: '#ccc', mb: 2 }} />
                  <Typography color="textSecondary" gutterBottom>
                    Upload VM Image
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    sx={{ cursor: 'not-allowed' }}
                    title="Image upload disabled for now"
                  >
                    Select Image
                  </Button>
                </>
              )}
              <input type="file" ref={fileInputRef} onChange={handleImageUpload} accept="image/*" hidden />
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" gap={2}>
            <Typography variant="h6">VM Details</Typography>

            <TextField label="Name" fullWidth value={vmName} onChange={(e) => setVmName(e.target.value)} />
            <TextField label="Category" fullWidth value={selectedCategory} disabled />
            <TextField label="Bay" fullWidth value={selectedBay} disabled />

            <FormControl fullWidth disabled>
              <InputLabel>Brand (Disabled)</InputLabel>
              <Select value={selectedBrand} label="Brand">
                <MenuItem value="">
                  <em>Select Brand</em>
                </MenuItem>
                {brands.map((brand) => (
                  <MenuItem key={brand} value={brand}>
                    {brand}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Box display="flex" gap={2}>
                <DatePicker
                  label="Start Date"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  slotProps={{
                    textField: {
                      fullWidth: true
                    }
                  }}
                  format="dd/MM/yyyy"
                  minDate={new Date()}
                />
                
                <DatePicker
                  label="End Date"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  slotProps={{
                    textField: {
                      fullWidth: true
                    }
                  }}
                  format="dd/MM/yyyy"
                  minDate={startDate || new Date()}
                />
              </Box>
            </LocalizationProvider>
          </Box>
        </Box>

        <Box mt={3}>
          <Box display="flex" gap={2} flexWrap="wrap">
            <Button
              variant="outlined"
              startIcon={<CloudUploadIcon />}
              onClick={() => excelInputRef.current?.click()}
              title={excelFileName || 'Upload Excel'}
              sx={{ maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
            >
              {excelFileName || 'Upload Excel'}
            </Button>

            <Button variant="outlined" color="success" startIcon={<DownloadIcon />} onClick={downloadSampleExcel}>
              Download Sample Excel
            </Button>

            <input type="file" ref={excelInputRef} onChange={handleExcelUpload} accept=".xlsx,.xls,.csv" hidden />
          </Box>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleReset}>
          Reset
        </Button>
        <Button variant="contained" onClick={handleSubmit}>
          Save Configuration
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VMConfigComponent;
